export default {
  productCode: '产品代码',
  productName: '产品名称',
  plant: '仓库',
  specialCode: '特殊产品编码',
  specialType: '特殊产品类型',
  exceptionType: '异常类型',
  createTime: '创建时间',
  lastUpdatedBy: '最后更新用户',
  lastUpdateTime: '最后更新时间',
  disableConfirm: '禁用后该 SKU 将不再按此特殊编码参与通道校验；若需再次使用须新建记录。是否继续？',
  productCodeEnterHint: '输入产品代码后按回车加载产品名称',
  specialCodeSelectLabel: '特殊产品编码',
  mandatoryFields: '请补充完整必填信息再进行提交。',
  errorcode_invalid_format: '此产品代码格式无效，请输入有效产品代码，如IF0696-001。',
  errorcode_436: '此产品代码无效，请输入有效产品代码，如IF0696-001。',
  errorcode_7003: '此产品代码和仓库组合已存在，请直接在页面搜索后再进行编辑及更新。'
}
